import { Progressbar } from 'common/components/progressbar';
import React from 'react';

interface LiveCardProgressProps {
  progress: number;
  continueWatchingProgress?: number | number[] | false;
  visible?: boolean;
}

function LiveCardProgress({ progress, visible, continueWatchingProgress }: LiveCardProgressProps) {
  return (
    <div className={`live-card-progress-container ${!visible ? 'visible' : ''}`}>
      <Progressbar
        safeArea={false}
        active={true}
        value={[continueWatchingProgress?.[0] || 0, progress]}
        background
      />
    </div>
  );
}

export default React.memo(LiveCardProgress);
